<template>
    <EditComponent dialog-id="admin-tools" open-dialog-event="dev-tools:edit-mode" size="default">
        <template #edit-header>Admin Tools</template>
        <template #edit-body>
            <VJoyTabs v-model:selected-tab="selectedTab">
                <VJoyTab tab="old-admin-tab" label="Admin Panel">
                    <AdminTab />
                </VJoyTab>
                <VJoyTab tab="developer-tools-tab" label="Developer Tools">
                    <DevWebPreferences />
                    <DevInvitationPoint />
                    <DevRefreshStatistics />
                </VJoyTab>
            </VJoyTabs>
        </template>
    </EditComponent>
</template>

<script setup lang="ts">
    import {onMounted, onUnmounted, ref} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyTab, VJoyTabs} from '@maltjoy/core-vue';
    import AdminTab from '~/components/admin-section-tabs/AdminTab.vue';
    import DevInvitationPoint from '~/components/admin-section-tabs/dev-tool/DevInvitationPoint.vue';
    import DevRefreshStatistics from '~/components/admin-section-tabs/dev-tool/DevRefreshStatistics.vue';
    import DevWebPreferences from '~/components/admin-section-tabs/dev-tool/DevWebPreferences.vue';
    import EditComponent from '~/components/edit/EditComponent.vue';
    import {eventBus} from '~/config/events';
    import {useProfileStore} from '~/store/profileStore';
    import {useWebPreferencesStore} from '~/store/webPreferences.store';

    const {getWebPreferences} = useWebPreferencesStore();
    const {profile} = storeToRefs(useProfileStore());

    const selectedTab = ref('old-admin-tab');

    async function reloadWebPreferences() {
        await getWebPreferences(profile.value!.accountId);
    }

    onMounted(async () => {
        await reloadWebPreferences();
        eventBus.on('onboarding:closed', reloadWebPreferences);
    });

    onUnmounted(() => {
        eventBus.off('onboarding:closed', reloadWebPreferences);
    });
</script>
